import { useEffect, useState } from "react";
import Header from "./Header";
import AOS from "aos";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import "aos/dist/aos.css";
import './contact.css'

function ContactUs() {
    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            const hero = document.querySelector(".contact-hero");

            if (hero) {
                hero.style.backgroundPositionY = -(scrolled * 0.3) + "px";
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        AOS.init();
    }, []);

    const [loading, setLoading] = useState(false);
    const [formMessage, setFormMessage] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        subject: "",
        message: "",
        newsletter: false,
    });

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const { firstName, lastName, email, message, subject } = formData;

        if (!firstName || !lastName || !email || !message || !subject) {
            setFormMessage({
                type: "error",
                text: "Please fill in all required fields.",
            });
            return;
        }

        if (!validateEmail(email)) {
            setFormMessage({
                type: "error",
                text: "Please enter a valid email address.",
            });
            return;
        }

        setLoading(true);

        setTimeout(() => {
            setFormMessage({
                type: "success",
                text: "Thank you for contacting us! We'll get back to you within 24 hours.",
            });

            setFormData({
                firstName: "",
                lastName: "",
                email: "",
                company: "",
                subject: "",
                message: "",
                newsletter: false,
            });

            setLoading(false);
        }, 1500);
    };



    const faqs = [
        {
            question: "How does AI-powered patent protection work?",
            answer:
                "Our AI system helps you draft your invention summary, organize technical flow, and suggest early claim language. This creates a solid foundation that our expert patent attorneys then refine, strengthen, and align with your business goals. The result is a high-quality patent prepared faster and more affordably than traditional methods.",
        },
        {
            question: "What industries do you specialize in?",
            answer:
                "We specialize in technology-focused industries including software, AI/ML, fintech, biotech, clean energy, hardware, and consumer electronics. Our team has extensive experience across these sectors and understands the unique patent challenges each one presents.",
        },
        {
            question: "How long does the patent process take with your service?",
            answer:
                "Our AI-assisted process typically reduces drafting time by 40-60%. From initial consultation to filing, most patents are ready within 2-4 weeks, compared to 6-12 weeks with traditional firms.",
        },
        {
            question: "Do you offer free consultations?",
            answer: "Yes, we offer a free 30-minute consultation to discuss your invention, assess patentability, and explain our process. This helps you understand the potential protection options and costs before committing to our service.",
        },
        {
            question: "What makes Ask Jeeves IP different from traditional patent firms?",
            answer: "Unlike traditional firms that rely solely on manual processes, we combine AI efficiency with expert legal strategy. This allows us to deliver higher quality patents faster and at a more affordable price. Our platform also provides real-time collaboration, transparent pricing, and a founder-friendly approach designed specifically for startups and innovators.",
        },
    ];
    const toggleFAQ = (index) => {
        if (activeIndex === index) {
            setActiveIndex(null);
        } else {
            setActiveIndex(index);
        }
    };

    return (
        <>
            <Header />
            {/* Contact Hero Section  */}
            <section className="contact-hero section-container">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>

                <div className="content-container">
                    <div className="hero-content">
                        <h1 className="hero-title" data-aos="fade-up">
                            Contact Ask Jeeves IP
                        </h1>

                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">
                            Have questions about AI-powered patent protection? We're here to
                            help. Reach out to our team of experts for personalized guidance on
                            securing your intellectual property.
                        </p>

                        <div className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                            <i className="fas fa-headset"></i>
                            Get Your Free Consultation Today
                        </div>
                    </div>
                </div>
            </section>
            {/* Contact Info Section */}
            <section className="contact-info-section section-container">
                <div className="content-container">
                    <div className="info-cards">

                        <div className="info-card" data-aos-delay="100">
                            <div className="card-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <h3>Our Office</h3>
                            <p>
                                123 Innovation Drive <br />
                                San Francisco, CA 94107 <br />
                                United States
                            </p>
                        </div>

                        {/* <div className="info-card" data-aos="fade-up" data-aos-delay="200">
                            <div className="card-icon">
                                <i className="fas fa-phone"></i>
                            </div>
                            <h3>Phone Number</h3>
                            <p>
                                +1 (555) 123-4567 <br />
                                Mon-Fri, 9am-6pm PST
                            </p>
                            <a href="tel:+15551234567" className="card-link">
                                Call Now
                            </a>
                        </div> */}

                        <div className="info-card" data-aos="fade-up" data-aos-delay="300">
                            <div className="card-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <h3>Email Address</h3>
                            <p>
                                hello@askjeevesip.com <br />
                                support@askjeevesip.com
                            </p>
                            <a href="mailto:hello@askjeevesip.com" className="card-link">
                                Email Us
                            </a>
                        </div>

                        <div className="info-card" data-aos="fade-up" data-aos-delay="400">
                            <div className="card-icon">
                                <i className="fas fa-clock"></i>
                            </div>
                            <h3>Working Hours</h3>
                            <p>
                                Monday - Friday: 9:00 AM - 6:00 PM <br />
                                Saturday: 10:00 AM - 2:00 PM <br />
                                Sunday: Closed
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            {/* Contact Form Section  */}
            <section className="contact-form-section section-container">
                <div className="content-container">
                    <div className="section-header">
                        <h2>Get In Touch</h2>
                        <p>
                            Fill out the form below and our team will get back to you within 24
                            hours.
                        </p>
                    </div>

                    <div className="form-wrapper">
                        <div className="form-container">

                            <form className="contact-form" id="#contact-form" onSubmit={handleSubmit}>

                                {formMessage && (
                                    <div
                                        className={
                                            formMessage.type === "success"
                                                ? "form-success"
                                                : "form-error"
                                        }
                                    >
                                        <i
                                            className={`fas ${formMessage.type === "success"
                                                ? "fa-check-circle"
                                                : "fa-exclamation-circle"
                                                }`}
                                        ></i>
                                        <span>{formMessage.text}</span>
                                    </div>
                                )}

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>First Name *</label>
                                        <input
                                            type="text"
                                            name="firstName"
                                            placeholder="Enter your first name"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Last Name *</label>
                                        <input
                                            type="text"
                                            name="lastName"
                                            placeholder="Enter your last name"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Email Address *</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Enter your email address"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Company Name</label>
                                        <input
                                            type="text"
                                            name="company"
                                            placeholder="Enter your company name"
                                            value={formData.company}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Subject *</label>
                                    <select
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select a topic</option>
                                        <option value="patent-consultation">
                                            Patent Consultation
                                        </option>
                                        <option value="pricing-info">Pricing Information</option>
                                        <option value="technical-support">Technical Support</option>
                                        <option value="partnership">Partnership Inquiry</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Your Message *</label>
                                    <textarea
                                        name="message"
                                        rows="5"
                                        placeholder="Please describe your inquiry..."
                                        value={formData.message}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="checkbox-group">
                                    <input
                                        type="checkbox"
                                        name="newsletter"
                                        checked={formData.newsletter}
                                        onChange={handleChange}
                                    />
                                    <label>
                                        I'd like to receive updates about AI patent trends and tips
                                    </label>
                                </div>

                                <button type="submit" className="submit-btn" disabled={loading}>
                                    {loading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin"></i> Sending...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-paper-plane"></i> Send Message
                                        </>
                                    )}
                                </button>
                            </form>
                            <div className="form-sidebar">
                                <div className="sidebar-content">
                                    <h3>Why Contact Us?</h3>

                                    <ul className="sidebar-list">
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            <span>Personalized patent strategy</span>
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            <span>Transparent pricing</span>
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle"></i>
                                            <span>Expert AI + legal guidance</span>
                                        </li>
                                    </ul>

                                    <div className="sidebar-contact">
                                        <h4>What Happens Next?</h4>
                                        
                                        <ul className="sidebar-list">
                                            <li>
                                                <i className="fas fa-arrow-right"></i>
                                                <span>Submit your inquiry</span>
                                            </li>
                                            <li>
                                                <i className="fas fa-arrow-right"></i>
                                                <span>Our patent team reviews your needs</span>
                                            </li>
                                            <li>
                                                <i className="fas fa-arrow-right"></i>
                                                <span>Receive expert guidance within 1 business day</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="faq-section section-container">
                <div className="content-container">
                    <div className="section-header">
                        <h2>Frequently Asked Questions</h2>
                        <p>Find answers to common questions about our services and process</p>
                    </div>

                    <div className="faq-container">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                                // data-aos="fade-up"
                                data-aos-delay={(index + 1) * 100}
                            >
                                <div
                                    className="faq-question"
                                    onClick={() => toggleFAQ(index)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <h3>{faq.question}</h3>
                                    <i className="fas fa-chevron-down"></i>
                                </div>

                                {activeIndex === index && (
                                    <div className="faq-answer">
                                        <p>{faq.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* Map Section  */}
            <section className="map-section section-container">
                <div className="content-container">
                    <div className="section-header" data-aos="fade-up">
                        <h2>Visit Our Office</h2>
                        <p>Located in the heart of San Francisco's innovation district</p>
                    </div>

                    <div className="map-container">
                        <div className="map-wrapper" data-aos="fade-right">
                            <div className="map-placeholder">
                                <i className="fas fa-map-marked-alt"></i>
                                <h3>Our Headquarters</h3>
                                <p>123 Innovation Drive, San Francisco, CA 94107</p>
                                <p className="map-note">
                                    Visit our office or connect with our patent experts for a confidential consultation.
                                </p>
                            </div>
                        </div>

                        <div className="map-info" data-aos="fade-left">
                            <h3>Getting Here</h3>

                            <div className="transport-options">
                                <div className="transport-option">
                                    <i className="fas fa-subway"></i>
                                    <div>
                                        <h4>Public Transit</h4>
                                        <p>10 min walk from Montgomery BART station</p>
                                    </div>
                                </div>

                                <div className="transport-option">
                                    <i className="fas fa-car"></i>
                                    <div>
                                        <h4>Parking</h4>
                                        <p>Paid parking available in building garage</p>
                                    </div>
                                </div>

                                <div className="transport-option">
                                    <i className="fas fa-bicycle"></i>
                                    <div>
                                        <h4>Bike Friendly</h4>
                                        <p>Bike racks and shower facilities available</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            {/* CTA Section  */}
            <section className="contact-cta section-container">
                <div className="content-container">
                    <div className="cta-content" data-aos="fade-up">
                        <h2 className="cta-title">Ready to Secure Your Innovations?</h2>
                        <p className="cta-text">Join hundreds of startups and innovators who trust Ask Jeeves IP for patent protection that's fast, affordable, and built to last.</p>
                        <div className="ctac-buttons">
                            <Link to="/contact" className="ctac-btn-primary">Start Your Patent Today</Link>
                            <a href="mailto:hello@askjeevesip.com" className="ctac-btn-secondary">
                                <i className="fas fa-envelope"></i>
                                Email Us Now
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>

    );
}

export default ContactUs;